import React from "react";
import {
  Button,
  Dialog as MUIDialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

export default function DeleteDialog({
  dialogState,
  setDialogState,
  handleAgree,
}) {
  const handleClose = () => {
    setDialogState({
      state: false,
      id: "",
    });
  };

  return (
    <React.Fragment>
      <MUIDialog open={dialogState.state} onClose={handleClose}>
        <DialogTitle style={{ paddingBottom: "4px" }}>
          Delete Comment
        </DialogTitle>

        <DialogContent>
          <DialogContentText>
            If you want to delete the comment click on delete to proceed
            further.
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          <Button
            onClick={() => {
              handleAgree();
              handleClose();
            }}
            variant="contained"
            style={{ background: "#d32f2f", color: "#fff" }}
          >
            Delete
          </Button>

          <Button
            onClick={handleClose}
            variant="outlined"
            color="primary"
            autoFocus
          >
            Cancel
          </Button>
        </DialogActions>
      </MUIDialog>
    </React.Fragment>
  );
}
